import Moment from 'moment'

export { formatDate, loadDate, daysBetween, toIsoUtc, isValidDate }

export const MILLIS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 *
 * @param {string} dateString ISO-8601
 * @param {string} format optional output format, defaults to 'YYYY/MM/DD'
 * @param {string} defaultValue optional default value if the date is invalid
 * @returns {string} formatted date or the default value
 */
function formatDate(dateString, format, defaultValue) {
  const m = Moment(dateString);
  return m.isValid() ? m.format( format || 'YYYY/MM/DD' ) : defaultValue || ''
}

function loadDate(dateString) {
  if(!dateString) {
    return null;
  } else if (/\d{4}-\d{2}-\d{2}/.test(dateString)){
    return new Date(dateString); // created as UTC zone
  } else if (/^(?:\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{1,2}[-/]\d{1,2}[-/]\d{4})$/.test(dateString)){
    const d = new Date(dateString); // created as local zone
    return new Date(d.valueOf() - d.getTimezoneOffset()*60000);
  } else {
    return new Date(Date.UTC(1899, 11, 30) + parseInt(dateString, 10) * MILLIS_PER_DAY);
  }
}

function daysBetween(start, end) {
  return Math.ceil(Math.abs(end - start) / MILLIS_PER_DAY);
}

function toIsoUtc(date){
  return date instanceof Date? date.toISOString().slice(0, 10): null;
}

/**
 * checks if date is a valid Date object
 * @param {Date} date a Date object to check
 * @returns {boolean} is valid Date object
 */
function isValidDate(date){
  return date instanceof Date && !isNaN(date);
}
